import { Decimal } from 'decimal.js';
import { PriceDerivationOperation } from '../constants/price-derivation-operation.js';
// WHY: shared by computeAdjustedAmount and computeAdjustedAmountPrecise so the two operand types can never silently diverge on the formula itself
function adjust(basis, operation, value) {
    switch (operation) {
        case PriceDerivationOperation.INCREASE_PERCENT:
            return basis.times(value.dividedBy(100).plus(1));
        case PriceDerivationOperation.DECREASE_PERCENT:
            return basis.times(new Decimal(1).minus(value.dividedBy(100)));
        case PriceDerivationOperation.INCREASE_FIXED:
            return basis.plus(value);
        case PriceDerivationOperation.DECREASE_FIXED:
            return basis.minus(value);
        case 'set':
            return value;
    }
}
/**
 * Pure basis/operation/value math shared by the client's live preview and the server's
 * recompute-on-basis-change -- one implementation so the two can
 * never silently disagree on a derived price. Kept separate from any UI so the arithmetic is
 * unit-testable on its own.
 */
export function computeAdjustedAmount(basisAmount, operation, value) {
    return adjust(new Decimal(basisAmount), operation, new Decimal(value))
        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP)
        .toNumber();
}
// WHY: NUMERIC(28,9) carries more precision than a JS number can round-trip -- the server recompute path stays in Decimal end-to-end instead of casting through Number()
export function computeAdjustedAmountPrecise(basisAmount, operation, value) {
    return adjust(new Decimal(basisAmount), operation, new Decimal(value)).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
}
//# sourceMappingURL=compute-adjusted-amount.js.map